import { all, spawn } from '@redux-saga/core/effects';
import { combineReducers } from 'redux';
import { Environment } from './Environment';
// import { entitiesReducer } from './Entities/entitiesReducer';
// import { entitiesSagas } from './Entities/entitiesSagas';
import { featuresReducer } from '../Features/featuresReducer';
import { featuresSagas } from '../Features/featuresSagas';
// import { pagesReducer } from '../Pages/pagesReducer';
import { pagesSagas } from '../Pages/pagesSagas';
// import { snippetReducer } from '../Snippets/snippetReducer';
// import { snippetSagas } from '../Snippets/snippetSagas';
import {
  historyListenerStore,
  historyListenerSagas,
  progressNotifierStore,
  progressNotifierSagas,
  messageNotifierStore,
} from '@mvf/product-components';
import { ReducerStoreProps } from '@mvf/product-components/redux';
import { router } from '../Pages/router';

const application = 'appwiki-link-shield-frontend';

const storeBuiltAt = localStorage.getItem(`builtAt:${application}`);
const builtAt = Environment.BUILT_AT;
if (storeBuiltAt === null || storeBuiltAt !== builtAt) {
  localStorage.removeItem(`persist:${application}`);
  if (builtAt) {
    localStorage.setItem(`builtAt:${application}`, builtAt);
  }
}

export const reducers = combineReducers({
  ...historyListenerStore,
  ...progressNotifierStore,
  ...messageNotifierStore,
  // entities: entitiesReducer,
  features: featuresReducer,
  // pages: pagesReducer,
  // snippets: snippetReducer,
});

export type IStoreProps = ReducerStoreProps<typeof reducers>;

export function* rootSagas() {
  yield spawn(historyListenerSagas, router);
  yield all([
    progressNotifierSagas(),
    // entitiesSagas(),
    featuresSagas(),
    pagesSagas(),
    // snippetSagas(),
  ]);
}

export const rootReducers = () => reducers;
